<template>
  <div class="gw_filter_body">
    <slot
      name="filterbody"
      :visibleFields="visibleFields"
      :methods="slotMethods"
    >
      <div
        v-if="asRow"
        class="gw_filter_body_row"
      >
        <GwSelect
          v-for="field in visibleFields"
          :key="field.id"
          class="gw_filter_body_select gw_loading_text"
          :title="field.title"
          :options="field.options"
          :slotPrefix="field.slotPrefix"
          :tstPrefix="field.field_name"
          :hasArrow="field.picker !== 'UrlValueExposed'"
          placement="bottom-start"
        >
          <!-- :hasArrow="field.picker !== 'UrlValueExposed' && field.selection !== 'GwBtnsExposed'" -->
          <template #select_selected_options>
            <GwFilterSelectionComponent
              :loading="loadings.includes(field.id)"
              :field
              @update:field="handleUpdate"
            />
          </template>
          <template #select_menu>
            <GwFilterPickerComponent
              class="gw_menu"
              style="padding: 0.5rem"
              data-gwmenu="noclose"
              :field
              @update:field="handleUpdate"
            />
          </template>
        </GwSelect>

        <GwFilterBtns
          v-if="filterActive"
          :hasSaveBtn="hasSaveBtn"
          :hasClearBtn="hasClearBtn"
          :filterUrlPrefix="filterUrlPrefix"
          :filter="filter"
          @click:clear="updateUrl({})"
          @click:save="openSaveFilterDialog"
        />
      </div>
    </slot>
  </div>
</template>

<script>
import GwFilterBtns from '@/components/DataTables/Filters/new/GwFilterBtns.vue'
import GwFilterSelectionComponent from '@/components/DataTables/Filters/new/GwFilterSelectionComponent.vue'
import { mock } from '@/components/DataTables/Filters/new/filter_helpers'
import { toggleArr } from '@/helpers/helpers'
import { sanitizeQuery, getSanitizedBoardFromString } from '@/store/router/router'
import { rangeTableGroups } from '@/helpers/solution'
import { t } from '@/locales/i18n'
import format_mix from '@/mixins/format_mix'
import fetch_mix from '@/mixins/fetch_mix'
import { isValid, isAfter, parseISO, formatISO, startOfDay, endOfDay } from 'date-fns'
import GwFilterPickerComponent from '@/components/DataTables/Filters/new/GwFilterPickerComponent.vue'
import GwSelect from '@/components/lib/GwSelect.vue'
// We should
// -add prop for custom Config
// -split curret config to parts (so its clear wchich field explains what api_config field)
// -expose slot for special UI situations (done in reportsFlopFilter) - so maybe we shiuld use always the slot and make another component for the default UI

// have a think  - not wery good how its done now
// - store of truth can now be - local, url, store, (we should add prop, or make it as prop always and only emit changes)
// - filter can be saved to store or not - not really clear

export default /** @type {any} */ {
  name: 'GwFilterBody',
  components: {
    GwFilterPickerComponent,
    GwSelect,
    GwFilterBtns,
    GwFilterSelectionComponent,
  },
  mixins: [format_mix, fetch_mix],
  props: {
    asRow: { type: Boolean, default: false },

    hasSaveBtn: { type: Boolean, default: true },
    hasClearBtn: { type: Boolean, default: true },
    filterUrlPrefix: { type: String, default: 'ff' },
    filterConfig: { type: Object, default: () => null },
    hasUrlUpdate: { type: Boolean, default: true },
    allTags: Array,
  },

  emits: ['update:filter'],
  data() {
    this.slotMethods = {
      handleUpdate: this.handleUpdate,
      openSaveFilterDialog: this.openSaveFilterDialog,
    }
    return {
      filter: {},
      fields: [],
      cachedItems: {},
      loadings: [],
    }
  },
  created() {
    // TODO NewFilters
    // done this way cos rn its the simplest way to go
    // in da future each table should be wrapped in a context component that will fetch and provide all the necessary data
    // rn its only the tags that are such exeption
    // the plan is that whole table configs will be fetched from the server (filter fields (including tags) and available sortings)
    // rnthis can be in created() cos all tables with tags are from local config
    if (this.tagField) {
      this.$store.dispatch('tags_get_tags', { tagType: this.tagField.tag_type })
    }
  },
  methods: {
    initialize() {
      this.setFields(this.filter)

      if (this.hasUrlUpdate) {
        setTimeout(() => {
          this.setFromUrl(this.$route.query, 'initialUpdate')
        })
      } else if (this.storeFilter?.params) {
        this.setFields(this.storeFilter.params, 'initialUpdate')
      }
    },
    updateFieldCachedItems({ field, item }) {
      if (!field.isRange) {
        this.cachedItems[field.field_name] = [
          ...(this.cachedItems[field.field_name] || []), //
          item,
        ]
      }
    },
    handleUpdate({ field, item, values, rangeValues }) {
      this.updateFieldCachedItems({ field, item })

      let vals = null
      if (field.isRange) {
        vals = rangeValues
      } else {
        item = item?.[field.idKey] || item || values?.[0]
        if (field.isSingle) {
          vals = field.value === item ? '' : item
        } else {
          vals = values ?? toggleArr({ arr: field.values, item })
        }
      }

      const filterPart = field.apiKeys.reduce(
        (a, key, idx) => ({ ...a, [key]: field.isRange ? vals[idx] : vals }),
        {},
      )
      const filter = {
        ...this.filter,
        ...(filterPart || {}),
      }

      this.setFields(filter)
    },

    updateUrl(filter) {
      if (!this.hasUrlUpdate) return

      let query = Object.keys(filter).reduce((a, key) => {
        const field = this.fields.find(f => f.apiKeys.includes(key))
        return {
          ...a, //
          [`${this.filterUrlPrefix}_${key}`]: field.isMultiple
            ? filter[key].join(',')
            : filter[key],
        }
      }, {})
      query = sanitizeQuery(query)

      const unrelatedQuery = Object.keys(this.$route.query).reduce(
        (a, key) =>
          !key.startsWith(this.filterUrlPrefix) ? { ...a, [key]: this.$route.query[key] } : a,
        {},
      )
      query = {
        ...unrelatedQuery,
        ...query,
      }
      this.$router.replace({ query }).catch(() => {})
    },
    setFromUrl(query, initialUpdate) {
      const filter = Object.keys(query).reduce((a, urlKey) => {
        if (urlKey.startsWith(this.filterUrlPrefix)) {
          const key = urlKey.replace(`${this.filterUrlPrefix}_`, '')
          const field = this.fields.find(f => f.apiKeys.includes(key))
          if (!field) return a

          const qq = [query[urlKey]].flat().join(',') // in case someone pastes actuall array to url
          let vals = qq.split(',')
          vals = field.isMultiple ? vals : vals[0]
          const r = {
            ...a, //
            [key]: vals,
          }
          return r
        }
        return a
      }, {})

      if (!initialUpdate && JSON.stringify(filter) === JSON.stringify(this.filter)) {
        return
      }
      this.setFields(filter, initialUpdate)
    },
    setFields(filter, initialUpdate) {
      const conf = [
        {
          selection: 'hidden',
          picker: 'in_table_as_a_star',
          getTitle: () => '-',
          match: {
            filter_ui_type: ['STAR'],
          },
        },
        {
          selection: 'GwBtns',
          picker: 'GwColorPicker',
          match: {
            field_name: ['color_hex', 'player_label_color'],
          },
        },
        {
          selection: 'Datepicker',
          picker: 'Datepicker',
          getTitle: () => t('table_filter.label.date'),
          match: {
            filter_ui_type: ['DATETIME'],
          },
          getCheckedValues: ({ rangeValues }) => {
            const from = rangeValues[0]
            const to = rangeValues[1]
            if ([from, to].some(i => !isValid(parseISO(i)))) return null
            if (isAfter(parseISO(from), parseISO(to))) return null
            return rangeValues
          },
          getApiTransform: ({ field, filterParams }) => {
            let res = { ...filterParams }
            field.apiKeys.forEach((key, index) => {
              if (res[key]) {
                res[key] =
                  index === 0
                    ? formatISO(startOfDay(parseISO(filterParams[field.apiKeys[0]])))
                    : formatISO(endOfDay(parseISO(filterParams[field.apiKeys[1]])))
              }
            })
            return res
          },
        },
        {
          selection: 'HandsRowMaxed',
          picker: 'CardGroupesPicker',
          match: {
            filter_ui_type: ['HAND'],
          },
          getLocalOptions: () => rangeTableGroups(),
        },
        {
          selection: 'CardsRowSimple',
          picker: 'CardsPicker',
          match: {
            filter_ui_type: ['BOARD'],
          },
          getLocalOptions: ({ urlVals }) =>
            [getSanitizedBoardFromString(urlVals[0] || '')].filter(i => i),
        },
        {
          selection: 'GwRangeSelect',
          picker: 'GwRangeSelect',
          match: {
            filter_ui_type: ['RANGE_SELECT'],
          },
          getCheckedValues: ({ options, rangeValues, idKey }) => {
            const from = rangeValues[0]
            const to = rangeValues[1]
            if (Number(from) > Number(to)) return null
            if (options && ![from, to].every(i => options.some(o => (o[idKey] || o) === i))) {
              return null
            }
            return rangeValues
          },
        },
        {
          selection: 'GwBtnsExposed',
          picker: 'GwBtns',
          match: {
            filter_ui_type: ['SELECT_EXPOSED'],
          },
        },
        {
          selection: 'GwBtns',
          picker: 'GwBtns',
          match: {
            filter_ui_type: ['SELECT', 'INPUT_AND_SELECT'],
          },
        },
        {
          selection: 'GwBtns',
          picker: 'GwPaginatedSearch',
          getPickerProps: ({ field }) => ({
            endpoint: `poker/hand-history/filters/search/${field.search_field_url}/`,
            immediate: true,
            callConfig: {
              apiVersion: 'v2',
              waitForCache: true,
              gwCacheAdd: true,
            },
            searchKey: 'search',
            dataHandler({ data, config }) {
              const res = data?.results || []
              return field.id === 'blinds' ? res.map(i => ({ ...i, id: i.id.toString() })) : res
            },
          }),
          getOptionsFetch: ({ field, idKey, urlVals }) => {
            const params = {
              [idKey]: urlVals,
            }
            const gwCacheId = `${field.fieldName}_${urlVals.join('_')}`
            return {
              endpoint: `poker/hand-history/filters/search/${field.search_field_url}/`,
              params,
              callConfig: {
                apiVersion: 'v2',
                gwCacheId,
              },
              dataHandler({ data, config }) {
                return data?.results || []
              },
            }
          },
          match: {
            filter_ui_type: ['SELECT_WITH_SEARCH'],
          },
        },
        {
          selection: 'none',
          picker: 'UrlValueExposed',
          getLocalOptions: ({ field }) => {
            const urlId = `${this.filterUrlPrefix}_${field.field_name}`
            const urlName = `${field.field_name}_name`
            const urlVal = {
              id: this.$route.query[urlId],
              name: this.$route.query[urlName] || this.$route.query[urlId],
            }
            return this.$route.query[urlId] ? [urlVal] : []
          },
          match: {
            filter_type: ['URL_CHOICE'],
          },
        },
        {
          selection: 'GwBtns',
          picker: 'TagsManager',
          hasClose: true,
          applyStyles: ({ item }) => `--clr-back:${item.color_hex}`,
          getLocalOptions: ({ field }) =>
            this.allTags || this.$store.getters.tags_get_all_tags(field.tag_type),
          getApiTransform: ({ field, filterParams }) => {
            const res = { ...filterParams }
            if (res.tags) {
              if (res.tags_anyall === 'all') {
                res.tag_ids_all = res.tags
              } else {
                res.tag_ids_any = res.tags
              }
            }
            delete res.tags_anyall
            delete res.tags
            return res
          },
          match: {
            filter_ui_type: ['TAGS_SELECT'],
          },
        },
        {
          // customSolutions >> positions
          selection: 'GwBtns',
          picker: 'GwBtns',
          getApiTransform: ({ field, filterParams }) => {
            const res = { ...filterParams }
            if (res.positions) {
              if (res.positions_anyall === 'all') {
                res.positions_all = res.positions
              } else {
                res.positions_any = res.positions
              }
            }

            if (res.tags) {
              if (res.tags_anyall === 'all') {
                res.tag_ids_all = res.tags
              } else {
                res.tag_ids_any = res.tags
              }
            }

            delete res.positions
            delete res.positions_anyall
            delete res.tags_anyall
            delete res.tags
            return res
          },
          match: {
            filter_ui_type: ['SELECT_WITH_ANYALL'],
          },
        },

        {
          // childs
          // tags_anyall, positions_anyall
          selection: 'hidden',
          picker: 'anyall',
          getTitle: () => '-',
          match: {
            filter_ui_type: ['SELECT_ANYALL'],
          },
        },
      ]

      function getSelectedOptions({ options, urlVals, idKey, field }) {
        return urlVals
          .map(id => options.find(o => (o[idKey] || o).toString() === id))
          .filter(i => i)
      }
      function getConfPart(fld) {
        let res = conf.find(i => {
          const match = Object.keys(i.match).some(key => i.match[key].includes(fld[key]))
          return match
        })
        if (!res) {
          console.log(fld)
          debugger
          res = {
            selection: 'error',
            getLocalOptions: () => [],
          }
        }
        return res
      }

      const data = this.filterConfig?.categories || mock.categories

      const res = data.reduce((acc, category) => {
        const fields = category.filters.map(fld => {
          const id = `${category.category_name}__${fld.field_name}`

          const apiKeys = fld.range_keys || [fld.field_name]
          const idKey = fld.filter_key || 'public_id'

          const isSingle = ['BOOL', 'SINGLE_CHOICE', 'URL_CHOICE'].includes(fld.filter_type)
          const isMultiple = ['MULTIPLE_CHOICE'].includes(fld.filter_type)
          const isRange = ['RANGE'].includes(fld.filter_type)

          const {
            selection,
            picker,
            getPickerProps,
            getLocalOptions,
            getOptionsFetch,
            getCheckedValues,
            getTitle,
            // for tags + anyall
            applyStyles,
            getApiTransform,
          } = getConfPart(fld)

          // if (getTitle) console.log(fld.field_name, getTitle?.({ field: fld }))

          const title =
            getTitle?.({ field: fld }) ||
            t(`table_filter.label.${fld.display_name || fld.field_name}`)
          const pickerProps = getPickerProps?.({ field: fld }) || null

          const urlVals = isRange ? null : [filter[apiKeys[0]] || []].flat()
          const options =
            getLocalOptions?.({ field: fld, urlVals }) ||
            fld.available_choices ||
            fld.available_type_choices ||
            this.cachedItems[fld.field_name] ||
            []

          let parts = {}
          let filterPart
          if (isRange) {
            let rangeValues = apiKeys.reduce((a, key) => [...a, filter[key]], [])
            rangeValues =
              getCheckedValues({
                idKey,
                options,
                rangeValues,
              }) || []

            filterPart = apiKeys.reduce((a, key, idx) => {
              const val = filter[key] ? rangeValues[idx] : null
              return val
                ? {
                    ...(a || {}),
                    [key]: val,
                  }
                : a
            }, null)

            parts = {
              rangeValues,
            }
          } else {
            let selectedOptions = getSelectedOptions({
              options,
              urlVals,
              idKey,
              field: fld,
            })

            // for tags
            if (applyStyles) {
              selectedOptions = selectedOptions.map(i => ({
                ...i,
                cssStyle: applyStyles({ item: i }),
              }))
            }

            const values = selectedOptions.map(i => i[idKey] || i)
            const value = isSingle ? values?.[0] || '' : null
            const optionsFetch = getOptionsFetch?.({ field: fld, idKey, urlVals }) || null
            const fetchOptions = optionsFetch ? urlVals.length !== values.length : false

            let filterValue = null
            if (!optionsFetch) {
              filterValue = isSingle ? value : values
            }

            const key = apiKeys[0]
            filterPart =
              filter[key] && filterValue?.length ? { [key]: filterValue ?? filter[key] } : null

            parts = {
              values,
              value,
              selectedOptions,
              options,
              fetchOptions,
              optionsFetch,
            }
          }

          return {
            id,

            field: fld,
            category: category.category_name,
            field_name: fld.field_name,
            display_key: fld.display_key || 'name',
            title,

            parent_field: fld.parent_field,
            child_field: null,
            parent_empty: false,

            isRange,
            isSingle,
            isMultiple,

            selection,
            picker,
            pickerProps,

            urlVals,
            options,

            ...parts,
            // rangeValues,
            // values,
            // value,
            // selectedOptions,
            // fetchOptions,
            // optionsFetch,

            idKey,
            apiKeys,
            filterPart,
            getApiTransform,
          }
        })
        return [...acc, ...fields]
      }, [])

      // for tags + anyall
      const childFields = res.filter(i => i.parent_field)
      if (childFields) {
        childFields.forEach(childField => {
          const parentField = res.find(i => i.field_name === childField.parent_field)
          if (parentField) {
            parentField.child_field = childField
            childField.parent_empty = !parentField.values.length
            // if (!parentField.values.length) {
            // childField.parentEmpty = true
            // childField.value = null
            // childField.values = []
            // childField.filterPart = null
            // }
          }
        })
        // res = res.filter(i => !i.parent_field)
      }

      this.fields = res
      this.setFromFields(initialUpdate)

      if (this.loaded) {
        const fetchFields = res.map(fld => (fld.fetchOptions ? fld : null)).filter(i => i)
        if (fetchFields.length) {
          this.fetchFieldsOptions(fetchFields)
        }
      }
    },
    setFromFields(initialUpdate) {
      const filter = this.fields.reduce((a, i) => ({ ...a, ...i.filterPart }), {})
      if (!initialUpdate && JSON.stringify(filter) === JSON.stringify(this.filter)) {
        return
      }

      // console.log(this.devFields)

      if (this.loaded) {
        this.filter = filter
        this.updateUrl(filter)

        // for tags + anyall, datepicker
        let filterParams = { ...filter }
        this.fields.forEach(fld => {
          if (fld.getApiTransform) {
            filterParams = fld.getApiTransform({ field: fld, filterParams })
          }
        })

        this.$emit('update:filter', { filter, filterParams, initialUpdate })
      }
    },

    fetchFieldsOptions(fields) {
      if (fields.some(fld => !fld.optionsFetch)) {
        console.error(
          'ERROR - optionsFetch not specified',
          fields.filter(fld => !fld.optionsFetch).map(fld => fld.id),
        )
        fields = fields.filter(fld => fld.optionsFetch({ field: fld }))
      }

      this.loadings = fields.map(f => f.id)

      const calls = fields.map(fld => {
        const call = {
          conf: {
            ...fld.optionsFetch,
            ...fld.optionsFetch.callConfig,
          },
          loading: false,
          loaded: false,
          status: 0,
          field: fld,
        }
        return this.fch_getData(call)
      })

      Promise.all(calls).then(results => {
        const cachedItems = results.reduce((a, result) => {
          const { call, data, error } = result

          const { field } = call
          if (error && !error.canceled) {
            const status = result?.error?.response?.status
            this.$store.dispatch(
              'messages',
              {
                type: 'error',
                status: 'err_message',
                statusMessages: {
                  _err_message: {
                    i18n: `messages.oops_error_filter_fetch_status`,
                    i18nParams: { title: field.title, status: status || 'unknown' },
                  },
                },
              },
              { root: true },
            )
          }

          const touchedFieldItems = this.cachedItems[field.field_name] || []
          const r = {
            ...a,
            ...{
              [field.field_name]: [
                ...touchedFieldItems, //
                ...(data?.results || []),
              ],
            },
          }
          return r
        }, {})

        this.cachedItems = {
          ...this.cachedItems, //
          ...cachedItems,
        }

        const keys = results.reduce((a, b) => [...a, ...b.call.field.apiKeys], [])
        const sanitizedFilter = keys.reduce((a, key) => {
          if (!(key in this.cachedItems || this.filter[key])) return a

          const field = this.fields.find(f => f.apiKeys.includes(key))
          const { idKey } = field
          return {
            ...a, //
            [key]: field.urlVals.filter(i =>
              this.cachedItems[key].some(ii => ii[idKey].toString() === i),
            ),
          }
        }, {})

        const filter = {
          ...this.filter,
          ...sanitizedFilter,
        }

        this.loadings = []
        this.setFields(filter)
      })
    },

    openSaveFilterDialog() {
      // find and set existion name if it exists
      const savedFilters = this.$store.getters.api_get_data('api_poker_saved_filters') || {
        results: [],
      }
      const filtersByType = savedFilters?.results.filter(
        i => i.filter_type === this.filterUrlPrefix,
      )

      const match = filtersByType.find(i => {
        const r = JSON.stringify(i.settings) === JSON.stringify(this.filter)
        return r
      })

      const item = {
        id: match?.id || null,
        name: match?.name || '',
        description: match?.description || '',
        favorite: match?.favorite || false,
        filter_type: this.filterUrlPrefix,
        query: this.filter,
      }
      this.$store.commit('fss_set', { key: 'fss_selected_filter', value: item })

      this.$store.dispatch(
        'router_set_dialogs',
        `save-filter-dialog_filter-${this.filterUrlPrefix}`,
      )
    },
  },
  computed: {
    visibleFields() {
      return this.fields.filter(i =>
        i.picker === 'UrlValueExposed' ? i.value : i.selection !== 'hidden',
      )
    },
    loaded() {
      return !!this.filterConfig?.categories && (this.tagField ? this.tagsCall?.loaded : true)
    },
    tagField() {
      const fields = this.filterConfig?.categories.reduce((a, i) => [...a, ...i.filters], []) || []
      const res = fields.find(fld => fld.field_name === 'tags')
      return res
    },
    tagsCall() {
      return this.tagField ? this.$store.getters.get_tags_call(this.tagField.tag_type) : null
    },
    devFields() {
      return this.fields.reduce((a, i) => ({ ...a, [i.id]: i }), {})
      // return this.fields.reduce((a, i) => [...a, i.field_name], [])
    },
    filterActive() {
      const res = Object.keys(this.filter).filter(key => !this.filter[key].parent_empty).length > 0
      return res
    },
    storeFilter() {
      return this.$store.getters[this.filterUrlPrefix]
    },
  },
  watch: {
    filterConfig: {
      immediate: true,
      handler: 'initialize',
    },
    tagsCall(call) {
      if (!call.loaded) return
      this.initialize()
    },
    allTags() {
      if (!this.tagsCall.loaded) return
      this.setFields(this.filter)
    },
    '$route.query': function () {
      if (!this.hasUrlUpdate) return
      this.setFromUrl(this.$route.query)
    },
    storeFilter() {
      if (!this.storeFilter || this.hasUrlUpdate) return
      this.setFields(this.storeFilter.params || {})
    },
  },
}
</script>
<style lang="scss" scoped>
.gw_filter_body {
  display: flex;
  flex-direction: column;
  &_row {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
</style>
